import React from 'react';
import {connect} from 'react-redux';
import {Grid, Card, Header, Loader, Item, Tab} from 'semantic-ui-react';
import _ from 'lodash';
import {Link} from 'react-router-dom';
import {ISOToDisplayDate} from 'common/utils';
import {
  canViewPostAwardEntities,
  canContinueApplications,
  canViewAndContinueApplication,
  isSubAOR,
} from 'go/security/permissions';
import {
  STATUS_AWARD_OFFERED,
  STATUS_AWARD_ACCEPTED,
  BEFORE_FINAL_SUBMISSION_STATUSES,
  STATUS_SUBMITTED_TO_FEMA,
  NUM_ACTIONS_TO_SHOW,
} from 'app-ui-componentlibrary/dist/common/constants';
import {Redirect} from 'react-router';
import REST from 'go/requests/rest';
import {ROLE_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {getUniqs} from 'common/utils';

const NEW_GRANT_ROLE_PERMISSIONS = [
  ROLE_MAP.ORGAOR.code,
  ROLE_MAP.ORGMEMBER.code,
  ROLE_MAP.ORGPGMMEMBER.code,
  ROLE_MAP.ORGGRNTWRITER.code,
  ROLE_MAP.ORGFINMEMBER.code,
];

export class MyGrantsCard extends React.PureComponent {
  constructor(props) {
    super(props);

    this.permObj = _.reduce(
      props.permissions,
      (result, permission) => {
        const [entityTypeId, , roleId] = permission.split(':');
        if (_.indexOf(result.types, entityTypeId) === -1) {
          result.entityTypes.push(entityTypeId);
        }
        if (_.indexOf(result.roles, roleId) === -1) {
          result.roles.push(roleId);
        }
        return result;
      },
      {entityTypes: [], roles: []}
    );
    if (
      !_.isEmpty(props.grants) &&
      _.intersection(NEW_GRANT_ROLE_PERMISSIONS, this.permObj.roles).length > 0
    ) {
      this.getActionsFromGrants(props.grants);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(prevProps.grants, this.props.grants) ||
      !_.isEqual(prevProps.tasks, this.props.tasks) ||
      !_.isEqual(prevProps.applications, this.props.applications) ||
      !_.isEqual(prevProps.subApplications, this.props.subApplications)
    ) {
      if (_.intersection(NEW_GRANT_ROLE_PERMISSIONS, this.permObj.roles).length > 0) {
        this.getActionsFromGrants(
          _.isEmpty(this.props.grants) ? prevProps.grants : this.props.grants
        );
      }
    }
  }

  state = {
    redirect: false,
    foDataLoaded: false,
    actions: [],
    pendingApplicationMap: {},
    applications: [],
  };

  getFoIds = (grants) => {
    // Get truthy FO ids
    return getUniqs(grants, 'fundingOpportunityId');
  };

  getActionsFromGrants = (grants) => {
    if (_.isEmpty(grants) || this.state.foDataLoaded) return null;

    const sortedGrants = _.reverse(_.sortBy(grants, ['grantId']));
    let actions = [];
    let count = 0;
    let includedGrants = [];
    const foIds = this.getFoIds(grants);

    while (actions.length < NUM_ACTIONS_TO_SHOW && _.has(sortedGrants, count)) {
      let grant = _.get(sortedGrants, count++);
      includedGrants.push(grant);
      const action = this.getActionFromGrant(grant);
      if (action) {
        actions.push(action);
      }
    }
    includedGrants = _.filter(includedGrants, (grant) =>
      _.includes(BEFORE_FINAL_SUBMISSION_STATUSES, _.get(grant, 'status'))
    );

    includedGrants = _.uniqBy(includedGrants, 'grantId');
    if (_.includes(this.props.toggles, 'elasticSearch-13734')) {
      return Promise.all(
        _.map(foIds, (foId) =>
          REST.fundingOpportunity.getFundingOpportunity(this.props.token, foId)
        )
      )
        .then((res) => Promise.all(_.map(res, (fo) => fo.json())))

        .then(async (fundingOpportunityData) => {
          const foIds = this.getFoIds(grants);
          actions = _.map(actions, (action) => {
            action.fundingOpportunityName = _.get(
              _.find(fundingOpportunityData, (fundingOpportunity) => {
                return (
                  fundingOpportunity.fundingOpportunityId == action.fundingOpportunityId
                );
              }),
              'fundingOpportunityName',
              'Grant NOFO Name'
            );

            this.setState({
              actions,
              foIds,
              foData: fundingOpportunityData,
            });
            return action;
          });
          this.flattenGrants(includedGrants);
        });
    } else {
      // Toggle for Dynamic Data Retrieval
      return Promise.all(
        _.map(foIds, (foId) =>
          REST.fundingOpportunity.getFundingOpportunity(this.props.token, foId)
        )
      )
        .then((res) => Promise.all(_.map(res, (fo) => fo.json())))

        .then((fundingOpportunityData) => {
          const foIds = this.getFoIds(grants);
          actions = _.map(actions, (action) => {
            action.fundingOpportunityName = _.get(
              _.find(fundingOpportunityData, (fundingOpportunity) => {
                return (
                  fundingOpportunity.fundingOpportunityId == action.fundingOpportunityId
                );
              }),
              'fundingOpportunityName',
              'Grant NOFO Name'
            );
            return action;
          });

          return new Promise((resolve, reject) => {
            this.setState(
              {
                actions,
                foIds,
                foData: fundingOpportunityData,
              },
              () => {
                let appPromises = _.map(includedGrants, (grant) => {
                  return REST.dynamicData
                    .getAllByGrantIdAndEntityType(
                      this.props.token,
                      grant.grantId,
                      'application'
                    )
                    .then((res) => REST.handler.handleResponse(res));
                });
                return Promise.all(appPromises)
                  .then((results) => resolve(results))
                  .catch((err) => reject(err));
              }
            );
          });
        })
        .then((res) => {
          const {foIds} = this.state;
          const appExtFOIds = foIds;
          let pendingApplicationMap = {};
          _.forEach(_.flatMap(res), (app) => {
            _.set(pendingApplicationMap, _.get(app, 'grantId'), app);
          });

          this.setState({
            pendingApplicationMap,
          });

          return Promise.all(
            _.map(appExtFOIds, (foId) =>
              REST.fundingOpportunity.getFundingOpportunitiesAppExtensionsForFO(
                this.props.token,
                foId
              )
            )
          );
        })
        .then((res) => Promise.all(_.map(res, REST.handler.handleResponse)))
        .then((foAppExtRes) => {
          const {foData, pendingApplicationMap} = this.state;

          const appExtensions = _.flatMap(foAppExtRes); // [{obj1}, {obj2}]
          _.forEach(pendingApplicationMap, (pendingApplication) => {
            pendingApplication.dueByDate = _.get(
              _.find(
                appExtensions,
                (appExt) =>
                  appExt.grantId === pendingApplication.grantId &&
                  appExt.applicationId == pendingApplication.entityId
              ),
              'extendedApplicationEndDate',
              _.get(
                _.find(
                  foData,
                  (fo) =>
                    pendingApplication.fundingOpportunityId == fo.fundingOpportunityId
                ),
                'aplcnEndDate'
              )
            );
          });

          this.setState({
            pendingApplicationMap,
            foDataLoaded: true,
          });
        })
        .catch((error) => console.log(error));
    }
  };

  flattenGrants = (res) => {
    Promise.resolve(res)
      .then((res) => {
        const {foIds} = this.state;
        const appExtFOIds = foIds;
        let pendingApplicationMap = {};
        _.forEach(_.flatMap(res), (app) => {
          _.set(pendingApplicationMap, _.get(app, 'grantId'), app);
        });

        this.setState({
          pendingApplicationMap,
        });

        return Promise.all(
          _.map(appExtFOIds, (foId) =>
            REST.fundingOpportunity.getFundingOpportunitiesAppExtensionsForFO(
              this.props.token,
              foId
            )
          )
        );
      })
      .then((res) => Promise.all(_.map(res, REST.handler.handleResponse)))
      .then((foAppExtRes) => {
        const {foData, pendingApplicationMap} = this.state;

        const appExtensions = _.flatMap(foAppExtRes); // [{obj1}, {obj2}]
        _.forEach(pendingApplicationMap, (pendingApplication) => {
          pendingApplication.dueByDate = _.get(
            _.find(
              appExtensions,
              (appExt) =>
                appExt.grantId === pendingApplication.grantId &&
                appExt.applicationId == pendingApplication.entityId
            ),
            'extendedApplicationEndDate',
            _.get(
              _.find(
                foData,
                (fo) => pendingApplication.fundingOpportunityId == fo.fundingOpportunityId
              ),
              'aplcnEndDate'
            )
          );
        });

        this.setState({
          pendingApplicationMap,
          foDataLoaded: true,
        });
      })
      .catch((error) => console.log(error));
  };

  makeAction = (
    grantData,
    linkText,
    link = '/',
    beforeRouting = () => new Promise((resolve) => resolve())
  ) => ({
    ...grantData,
    render: () => (
      <a
        key={grantData.grantId}
        href="#"
        title={`${linkText} for grant with id: ${grantData.grantId}`}
        onClick={(e) => {
          e.preventDefault();
          beforeRouting().then((res) => {
            this.setState({
              redirect: link,
            });
          });
        }}
      >
        {linkText}
      </a>
    ),
  });

  getTaskIdForGrant = (grantId) => {
    return _.get(
      _.find(this.props.tasks, (task) => task.grantId == grantId),
      'id'
    );
  };

  // intentionally not super extensible until rules svc implementation is prioritized
  getActionFromGrant = (grant) => {
    const relevantGrantData = {
      grantId: grant.grantId || grant.grantNumber,
      fundingOpportunityId: grant.fundingOpportunityId,
    };
    const grantStatus = _.get(grant, 'status');
    const taskId = this.getTaskIdForGrant(_.get(grant, 'grantId'));

    //link will be modified when Award Acceptance task is implemented
    if (_.isEqual(grantStatus, STATUS_AWARD_OFFERED) && taskId) {
      return this.makeAction(
        relevantGrantData,
        'Accept or decline award',
        `/tasks/${taskId}`
      );
    } else if (_.isEqual(grantStatus, STATUS_AWARD_ACCEPTED)) {
      return this.makeAction(
        relevantGrantData,
        'Manage grant',
        `/grant/${_.get(grant, 'grantId')}`
      );
    } else if (
      _.isEqual(grantStatus, STATUS_SUBMITTED_TO_FEMA) &&
      canViewPostAwardEntities(this.props.permissions)
    ) {
      return this.makeAction(
        relevantGrantData,
        'View application',
        `/grant/${_.get(grant, 'grantId')}`
      );
    } else if (_.includes(BEFORE_FINAL_SUBMISSION_STATUSES, _.get(grant, 'status'))) {
      if (
        canContinueApplications(
          this.props.permissions,
          `${_.get(grant, 'status')}`,
          _.get(grant, 'extendedApplicationEndDate')
            ? appExtension.extendedApplicationEndDate
            : _.get(grant, 'aplcnEndDate'),
          this.props.toggles,
          _.get(grant, 'fundingOpportunityId')
        )
      ) {
        return this.makeAction(
          relevantGrantData,
          'Continue application',
          `/application/${_.get(grant, 'grantId')}-application/edit`
        );
      } else {
        return this.makeAction(
          relevantGrantData,
          'View application',
          `/grant/${_.get(grant, 'grantId')}`
        );
      }
    }
  };

  getGrantOrApplicationContent = (actionLink) => {
    const grantId = actionLink.grantId;
    const pendingApplication = this.state.pendingApplicationMap[grantId];

    const canContinue =
      _.includes(BEFORE_FINAL_SUBMISSION_STATUSES, _.get(pendingApplication, 'status')) &&
      canViewAndContinueApplication(this.props.permissions);

    return this.state.foDataLoaded ? (
      <Item.Content>
        <Item.Description as="strong">
          {actionLink.fundingOpportunityName}
        </Item.Description>
        {canContinue ? (
          <div className="padding-left">
            Application ID: {pendingApplication.grantId}
            <br />
            Due date:{' '}
            {ISOToDisplayDate(pendingApplication.dueByDate, {
              showHours: true,
              showDate: true,
            })}
            <br />
            {this.makeAction(
              pendingApplication,
              'Continue application',
              `/application/${pendingApplication.entityId}/edit`
            ).render()}
          </div>
        ) : (
          <div className="padding-left">
            Grant ID: {grantId}
            <br />
            {actionLink.render()}
          </div>
        )}
      </Item.Content>
    ) : null;
  };

  render() {
    const {actions, redirect, foDataLoaded} = this.state;
    const {applications, subApplications} = this.props;
    const sortedSubApplications = _.sortBy(subApplications, function (dateObj) {
      return new Date(dateObj.modifyDate);
    }).reverse();
    const user = isSubAOR(this.props.permissions);
    const manageTeamOrgSubOrgToggle = _.get(this.props, 'toggles', []).includes(
      'manageTeamOrgSubOrg'
    );
    let apps = [];
    let appsAndSubApps = [];
    if (!_.isEmpty(applications)) {
      apps = applications.slice(0, NUM_ACTIONS_TO_SHOW);
      apps = _.uniqBy(apps, 'grantId');
    }
    if (
      manageTeamOrgSubOrgToggle
        ? user && !_.isEmpty(subApplications)
        : !_.isEmpty(subApplications)
    ) {
      appsAndSubApps = _.concat(
        apps,
        sortedSubApplications.slice(0, NUM_ACTIONS_TO_SHOW)
      );
    }
    let grants = _.concat(
      actions,
      _.orderBy(
        appsAndSubApps,
        [
          (app) =>
            app.payload.applicationTitle
              ? app.payload.applicationTitle.toLowerCase()
              : 'No application title provided',
        ],
        ['asc']
      )
    ).slice(0, NUM_ACTIONS_TO_SHOW);

    if (redirect) {
      return <Redirect push to={redirect} />;
    }

    return (
      <Grid.Column width={6}>
        <Card fluid>
          <Card.Content>
            <Header as="h3">My grants</Header>
            {(!this.props.loading && foDataLoaded) || applications ? (
              <React.Fragment>
                <Item.Group>
                  {_.size(grants) > 0 ? (
                    _.map(grants, (actionLink, index) =>
                      actionLink ? (
                        actionLink.grantId &&
                        actionLink.entityType !== 'subApplication' ? (
                          <Item key={index}>
                            {this.getGrantOrApplicationContent(actionLink)}
                          </Item>
                        ) : (
                          <Item key={index}>
                            <Item.Content>
                              <Item.Description as="strong">
                                {actionLink.payload !== undefined &&
                                actionLink.payload.applicationTitle !== undefined
                                  ? actionLink.payload.applicationTitle
                                  : 'No application title provided ' +
                                    actionLink.entityType}
                              </Item.Description>
                              <div className="padding-left">
                                Application Type:{' '}
                                {actionLink.payload !== undefined
                                  ? actionLink.payload.applicationTypeDescription
                                  : ''}
                                <br />
                                {actionLink.payload !== undefined ? (
                                  <a
                                    key={actionLink.payload.applicationTitle}
                                    href="#"
                                    title={`Continue subapplication: ${actionLink.payload.applicationTitle}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      new Promise((resolve) => resolve()).then((res) => {
                                        this.setState({
                                          redirect: `/subApplication/${actionLink.entityId}`,
                                        });
                                      });
                                    }}
                                  >
                                    Continue subapplication
                                  </a>
                                ) : (
                                  ''
                                )}
                              </div>
                            </Item.Content>
                          </Item>
                        )
                      ) : (
                        <Loader active inline="centered" content="Loading" />
                      )
                    )
                  ) : (
                    <p>You have no grant actions</p>
                  )}
                </Item.Group>
              </React.Fragment>
            ) : (
              <Loader active inline="centered" content="Loading" />
            )}
            {_.size(grants) > 0 && <Link to="/grants">View all grants</Link>}
          </Card.Content>
        </Card>
      </Grid.Column>
    );
  }
}
export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, null)(MyGrantsCard);
